/* eslint-disable react-hooks/exhaustive-deps */
import { connect, useSelector } from 'react-redux';
import { ScaleLoader } from 'react-spinners';
import { RootState } from 'store/reducers';
import { ExibotResponse } from 'types/apprasal.types';
import { createAccount, getBadgeTypeImage, history as locationHistory, userInterested } from '../utils/handler';
import { ContributedDomains, Reviews, StatisticsDetails, WhyChooseSaw } from '../views/components/CommonPages';

export const AppraisalDashboard: React.FC<any> = ({ buyDomain, handleSubmit, sendAppraisalToMail }: any): JSX.Element => {
  const { appraisalSearchHistory = [], appraisalSearchHistoryError } = useSelector((state: RootState) => state.appraisalReducer);
  // const dispatch = useDispatch();
  const appraisalCardView = (appraisals: ExibotResponse[]) => {
    return appraisals.length <= 3;
  };

  return (
    <div className="text-center">
      <div>
        {appraisalSearchHistoryError ? (
          <div className="waiting text-center mt-3">
            <span className=" ">{appraisalSearchHistoryError}</span>
          </div>
        ) : appraisalSearchHistory.length === 0 ? (<></>
          // <div className=" mt-3 ">
          //   <ScaleLoader color={'#ff7728;'} loading={true} height={40} width={5} radius={3} margin={3} />
          //   <div> Fetching history...</div>
          // </div>
        ) : (
          <>
            <div className="container mt-5 ">
              <div className="appraisal-history">
                <div className="main-text fs-30 mb-3">Here’s what you’ve already valued…</div>
                <div className="row">
                  {appraisalSearchHistory &&
                    appraisalSearchHistory?.map((history: ExibotResponse, index: number) => (
                      <div key={index} className={'card  mt-2 ' + (appraisalSearchHistory.length <= 3 ? 'col-12' : 'col-lg-4 col-md-12')}>
                        <div className={'card-body justify-content-between  ' + (appraisalSearchHistory.length <= 3 ? 'd-md-flex ' : '')}>
                          <div className="left">
                            <div className="domain-name theme-color">{history.domain}</div>
                            <div className="dull-color fs-12">Estimated Value (USD)</div>
                            <div>
                              <span className="domain-value">
                                {history.saw_appraised_value_formatted ? history.saw_appraised_value_formatted : `$ ${history.appraised_value}`}
                                {history.appraisalTypes && <i data-toggle="tooltip" title={history.appraisalTypes.info} className="fas fa-info-circle dull-color fs-18 ml-1"></i>}
                              </span>
                            </div>
                            {history.appraisalTypes ? (
                              <div className="domain-info">
                                <img src={getBadgeTypeImage({ type: history.appraisalTypes.type, info: history.appraisalTypes.info })} alt="type" className="domain-badge-type" data-toggle="tooltip" title={'appraisalDetails.appraisalTypes.type'} />
                                <span> {history.appraisalTypes.info}</span>
                              </div>
                            ) : (
                              <div className="row">
                                <br />
                              </div>
                            )}
                          </div>
                          <div className={'right appraisal-btn  mt-2 fw-normal' + (appraisalCardView(appraisalSearchHistory) ? '' : 'd-flex')}>
                            <div className="d-flex justify-content-md-end">
                              <button className={'fs-11 btn-grad btn normal-btn tt-u ' + (appraisalCardView(appraisalSearchHistory) ? '' : ' btn-grad-outline')} onClick={() => handleSubmit(history.domain)}>
                                More Info
                              </button>
                            </div>
                            {/* {showBuyButton() ? ( */}
                            <div className="d-flex justify-content-md-end">
                              <button className="fs-11 btn-grad btn normal-btn tt-u fw-normal"
                                // onClick={() => buyDomain(userInterested.buy, history.domain, history.saw_appraised_value)}
                                onClick={() => window.location.href = `https://saw.com/buy-domain?domain=${history.domain || ""}`}
                              >
                                Buy This Domain
                              </button>
                            </div>
                            {/* ) : null} */}
                            {/* {showSellButton() ? ( */}
                            <div className="d-flex justify-content-md-end">
                              <button
                                className="fs-11 btn-grad btn normal-btn tt-u d-flex align-items-center fw-normal"
                                onClick={() => {
                                  window.location.href = `https://saw.com/outbound-brokerage?domain=${history.domain || ""}`
                                  // localStorage.setItem('_sell_value', String(history.appraised_value));
                                  // localStorage.setItem('_sell_worth', String(history.saw_appraised_value));
                                  // locationHistory.push(`/sell-domain?domain=${history.domain}`);
                                  // dispatch({ type: SET_CONTACT_US_DOMAIN, payload: history.domain });
                                  // scrollDoc(docIds.appraisalContactUs);
                                  // buyDomain(userInterested.sell, history.domain);
                                }}
                              >
                                Sell This Domain
                              </button>
                            </div>
                            {/* ) : null} */}
                            <div className="d-flex justify-content-md-end">
                              <button className="fs-11 btn-primary primary-dark btn btn-normal fw-normal" onClick={() => sendAppraisalToMail(history.domain, index)} disabled={history.downloadingCertificate === true}>
                                {history.downloadingCertificate === true ? <i className="fa-solid fa-spinner fa-spin-pulse"></i> : <i className="fa-solid fa-file-pdf fs-16"></i>}
                                <span className="ml-2">Domain Appraisal Certificate</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
            <div className="want-to-discuss-container  row justify-content-center mt-5">
              <div className="container">
                <i className="fa-solid fa-circle-arrow-up fa-5x up-arrow-icon text-primary text-primary-dark ml--35 c-unset"></i>
                <div className="fs-25 mt-4">Want to discuss any of those?</div>
                <div className="main-text  mt-3">Get a Dedicated Domain Consultant From Saw.com For Under $20</div>
                <div className="mt-4 dedicated-domain-details">
                  <span>For just $19.95, we’ll set up a consultation with your very own domain consultant from Saw.com. They’ll spend a few hours learning more about your situation and talking you through the domain negotiation and acquisition process, before contacting you with a whole load of information about up to 5 separate domains.</span> <br />
                  <br />
                  <span>You’ll learn the registrant, value and timeline for purchase - as well as some advice on negotiation strategies. So, for the price of a few cups of coffee, you can get expert advice from a Domain Broker who’s been there, done that and got the T-shirt for some of the world’s largest brands and the internet’s most valuable domains.</span>
                </div>
                <div className="d-flex justify-content-center">
                  <button className="btn btn-grad mt-4" onClick={() => {window.location.href = `https://saw.com/buy-domain`}}>
                    Let's Do it
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="why-saw-container container">
        <div className="title">Why Choose Saw.com To Facilitate & Execute Your Premium Domain Sales & Acquisitions?</div>
        <WhyChooseSaw />

        <div className="row justify-content-center m-5">
          {/* {showBuyButton() ?  */}
          <button
            className="btn btn-grad"
            // onClick={() => createAccount()}
            onClick={() => window.location.href = `https://saw.com/buy-domain`}
          >
            Buy a domain
          </button>
          {/* : null} */}
          {/* {showSellButton() ? */}
          <button
            className="btn btn-primary primary-dark d-flex align-items-center tt-uppercase"
            onClick={
              () => {
                window.location.href = `https://saw.com/outbound-brokerage`
                // locationHistory.push(`/sell`);
                // locationHistory.push(`/sell-domain?formName=${formNames.appraisalSell}`);
                // dispatch({ type: SET_CONTACT_US_DOMAIN, payload: '' });
                // scrollDoc(docIds.appraisalContactUs);
              }
              // createAccount()
            }
          >
            Sell a domain
          </button>
          {/* : null} */}
        </div>
        <hr />
        <div className="sub-title mt-5">
          <ContributedDomains addAnd={true} />
        </div>
        <Reviews />
        <div className="statistics mb-4">
          <div className="title">Saw.com Is One of The World’s Leading Domain Brokerage Firms...</div>
          <StatisticsDetails />
        </div>
      </div>
      {/* <ContactUs /> */}
    </div>
  );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {})(AppraisalDashboard);
